import { Box } from '@material-ui/core';
import { newsItem } from 'Models/GetNewsModel';
import { FC, memo } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import './NewsItem.scss';

export type NewsItemProps = {
  newsItem: newsItem;
  onClick: () => void;
  itemID: string;
};

const NewsItem: FC<NewsItemProps> = memo(({ newsItem, onClick, itemID }) => {
  return (
    <Box 
      id="news-item" 
      onClick={onClick} 
      itemID={itemID}
      tabIndex={0}
      role="button"
      aria-label={newsItem?.HeadLine || 'Haberi aç'}
      onKeyDown={(e)=>{
        if(e.key === 'Enter' || e.key === ' '){
          e.preventDefault();
          onClick();
        }
      }}
    >
      <LazyLoadImage 
        src={newsItem?.WebCoverPictureUrl} 
        alt={newsItem?.HeadLine || 'Haber Görseli'}
        effect="opacity"
      />
    </Box>
  );
});
export default NewsItem;
